exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-1bdc2864] {\n    font-style: italic;\n}\n", ""]);

// exports
